import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  USER_CREATE,
  CHAPTER_LIST_DROPDOWN,
  USER_ROLE_LIST_DROPDOWN,
  CATEGORY_LIST_DROPDOWN,
  BUSINESS_SUB_CATEGORY_LIST_DROPDOWN,
  COUNTRY_LIST_DROPDOWN,
  STATE_LIST_DROPDOWN,
  CITY_LIST_DROPDOWN,
  REGION_LIST_DROPDOWN,
  BLOOD_GROUP_LIST_DROPDOWN,
  USER_LIST_DROPDOWN,
  // MEMBER_TYPE_LIST_DROPDOWN,
} from "../../routes/routes";
import Form from "react-bootstrap/Form";
import { toast } from "react-toastify";
import userIcon from "../../assets/images/user_icon.png";
import { USER_CREATED } from "../../constant/constant";
import { ValidationMessage, hasRole } from "../../components/Utils";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import "flatpickr/dist/themes/material_red.css";
import moment from "moment";
import { FullPageLoader } from "../../components/common/Loader"; // Import the loader component
import { Image } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const membershipDurationOptions = [
  { value: 1, label: "1 Year" },
  { value: 2, label: "2 Years" },
  { value: 3, label: "3 Years" },
  { value: 4, label: "4 Years" },
  { value: 5, label: "5 Years" },
];

const calcMembershipDueDate = (joiningDate, years = 1) => {
  if (!joiningDate) return "";
  return moment(joiningDate, "DD/MM/YYYY")
    .add(Number(years) || 1, "year")
    .subtract(1, "day")
    .format("DD/MM/YYYY");
};

const UserCreate = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    membership_status: 1,
    mobile_country_code: "91",
    whatsapp_country_code: "91",
    membership_duration_years: 1,
    date_time: moment().format("YYYY-MM-DD HH:mm"),
  });
  const [errors, setErrors] = useState({});
  const [countryOptions, setCountryOptions] = useState({});
  const [stateOptions, setStateOptions] = useState({});
  const [cityOptions, setCityOptions] = useState({});
  const [regionOptions, setRegionOptions] = useState({});
  const [chapterOptions, setChapterOptions] = useState({});
  const [roleOptions, setRoleOptions] = useState({});
  // const [memberTypeOptions, setMemberTypeOptions] = useState({});
  const [filter, setFilter] = useState([]);
  const [bloodGroupOptions, setBloodGroupOptions] = useState({});
  const [categoryOptions, setCategoryOptions] = useState({});
  const [subCategoryOptions, setSubCategoryOptions] = useState({});
  // const [isPANMandatory, setIsPANMandatory] = useState(true);
  // const [isGSTMandatory, setIsGSTMandatory] = useState(true);
  const [isPANMandatory, setIsPANMandatory] = useState(false);
  const [isGSTMandatory, setIsGSTMandatory] = useState(false);
  const [userOptions, setUserOptions] = useState({});
  const [showReferredByMember, setShowReferredByMember] = useState(false);
  const [showOthers, setShowOthers] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("password");
  const [type1, setType1] = useState("password");

  const selectStateRef = useRef(null);
  const selectCityRef = useRef(null);
  const selectRegionRef = useRef(null);
  const selectChapterRef = useRef(null);

  const handleStateClear = () => {
    selectStateRef.current.clearValue();
    selectCityRef.current.clearValue();
    selectRegionRef.current.clearValue();
    selectChapterRef.current.clearValue();
  };

  const handleCityClear = () => {
    selectCityRef.current.clearValue();
    selectRegionRef.current.clearValue();
    selectChapterRef.current.clearValue();
  };

  const handleRegionClear = () => {
    selectRegionRef.current.clearValue();
    selectChapterRef.current.clearValue();
  };

  const handleChapterClear = () => {
    selectChapterRef.current.clearValue();
  };

  /**   *
   * @param {*} input
   * @param {*} callback
   */

  const referredByOptions = [
    { value: 1, label: "Direct" },
    { value: 2, label: "Iraaya World Member" },
    { value: 3, label: "Others" },
  ];

  const auth_user = JSON.parse(localStorage.getItem("user"));

  const submit = async (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    setLoading(true);
    setBtnDisabled(true);
    if (
      Number(form.referred_by) === 3 &&
      form.referrer_mobile &&
      !/^\d{6,15}$/.test(form.referrer_mobile)
    ) {
      setErrors((prev) => ({
        ...prev,
        referrer_mobile: ["Referrer mobile number did not match the pattern."],
      }));
      setLoading(false);
      setBtnDisabled(false);
      return;
    }
    let requestBody = { ...form };
    axios
      .post(USER_CREATE, requestBody, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (res.status === 201 && res.data.success) {
          toast.success(USER_CREATED);
          navigate("/users");
        }
      })
      .catch((err) => {
        if (err.response.status === 422) {
          const error = err.response.data.error;
          setErrors(error);
          toast.error(err.response.data.msg);
        }
      })
      .finally(() => {
        setLoading(false);
        setBtnDisabled(false);
      });
  };

  const checkPanGstMandatory = (categoryId) => {
    if (Number(categoryId) === 202) {
      setIsPANMandatory(false);
      setIsGSTMandatory(false);
    } else {
      setIsPANMandatory(true);
      setIsGSTMandatory(true);
    }
  };

  useEffect(() => {
    let initialFilter = {};
    let initialForm = {
      membership_status: 1,
      mobile_country_code: "91",
      whatsapp_country_code: "91",
    };

    if (hasRole([6])) {
      initialForm.country_id = auth_user?.country_id;
    }
    if (hasRole([7])) {
      initialForm.country_id = auth_user?.country_id;
      initialForm.state_id = auth_user?.state_id;
    }
    if (hasRole([8])) {
      initialForm.country_id = auth_user?.country_id;
      initialForm.state_id = auth_user?.state_id;
      initialForm.city_id = auth_user?.city_id;
      initialFilter = {
        country_id: auth_user?.country_id,
        state_id: auth_user?.state_id,
        city_id: auth_user?.city_id,
      };
    }
    if (hasRole([2])) {
      initialForm.country_id = auth_user?.country_id;
      initialForm.state_id = auth_user?.state_id;
      initialForm.city_id = auth_user?.city_id;
      initialForm.region_id = auth_user?.region_id;
      initialFilter = {
        country_id: auth_user?.country_id,
        state_id: auth_user?.state_id,
        city_id: auth_user?.city_id,
        region_id: auth_user?.region_id,
      };
    }
    if (hasRole([3])) {
      initialForm.country_id = auth_user?.country_id;
      initialForm.state_id = auth_user?.state_id;
      initialForm.city_id = auth_user?.city_id;
      initialForm.region_id = auth_user?.region_id;
      initialForm.chapter_id = auth_user?.chapter_id;
      initialFilter = {
        country_id: auth_user?.country_id,
        state_id: auth_user?.state_id,
        city_id: auth_user?.city_id,
        region_id: auth_user?.region_id,
        chapter_id: auth_user?.chapter_id,
      };
    }

    setForm((prev) => ({ ...prev, ...initialForm }));
    setFilter(initialFilter);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch country data
        const countryResponse = await axios.get(COUNTRY_LIST_DROPDOWN);
        const fetchedCountryOptions = countryResponse.data.data;
        setCountryOptions(fetchedCountryOptions);

        // Fetch state data
        const stateResponse = await axios.get(STATE_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedStateOptions = stateResponse.data.data;
        setStateOptions(fetchedStateOptions);

        const cityResponse = await axios.get(CITY_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        setCityOptions(cityResponse.data.data);

        // Fetch region data
        const regionResponse = await axios.get(REGION_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedRegionOptions = regionResponse.data.data;
        setRegionOptions(fetchedRegionOptions);

        // Fetch chapter data
        const chapterResponse = await axios.get(CHAPTER_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedChapterOptions = chapterResponse.data.data;
        setChapterOptions(fetchedChapterOptions);

        // Fetch category data
        const categoryResponse = await axios.get(CATEGORY_LIST_DROPDOWN);
        const fetchedCategoryOptions = categoryResponse.data.data;
        setCategoryOptions(fetchedCategoryOptions);

        const subCategoryResponse = await axios.get(
          BUSINESS_SUB_CATEGORY_LIST_DROPDOWN,
        );
        setSubCategoryOptions(subCategoryResponse.data.data);

        // Fetch role data
        const roleResponse = await axios.get(USER_ROLE_LIST_DROPDOWN);
        const fetchedRoleOptions = roleResponse.data.data;
        setRoleOptions(fetchedRoleOptions);

        // Fetch user data
        const userResponse = await axios.get(USER_LIST_DROPDOWN, {
          params: {},
        });
        const fetchedUserOptions = userResponse.data.data;
        setUserOptions(fetchedUserOptions);

        // Fetch blood group data
        const bloodGroupResponse = await axios.get(BLOOD_GROUP_LIST_DROPDOWN);
        const fetchedBloodGroupOptions = bloodGroupResponse.data.data;
        setBloodGroupOptions(fetchedBloodGroupOptions);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [filter]);

  return (
    <div className="content-wrapper">
      <FullPageLoader visible={loading} />
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row">
            <div className="col-lg-6">
              <h5 className="page-title">Members</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#212b39"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                      </svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <Link to={"/users"}>
                    <span>Members List</span>
                  </Link>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <span className="active_breadcrumb">Create User</span>
                </li>
              </ol>
            </div>
            <div className="col-lg-6">
              <div className="pt-btn">
                <Link to={"/users"}>
                  <button type="button" className="btn btn-dark igoback_btn">
                    <i className="bx bx-exit"></i> back
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <div className="row">
          <div className="col-xl-12">
            <div className="card mb-4">
              <div className="card-header d-flex justify-content-between align-items-center">
                {/* <h5 className="mb-0">Create User</h5> */}
              </div>
              <div className="card-body">
                <form autoComplete="off" onSubmit={(e) => { e.preventDefault(); submit(e); }}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="name">
                          Name<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          name="member_name"
                          placeholder="Name"
                          autoComplete="off"
                          value={form?.name || ""}
                          onChange={(e) =>
                            setForm({ ...form, name: e.target.value })
                          }
                        />
                        <ValidationMessage error={errors} name="name" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="email">
                          Email<span className="text-danger">*</span>
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          name="member_email"
                          placeholder="Email"
                          autoComplete="off"
                          value={form?.email || ""}
                          onChange={(e) =>
                            setForm({ ...form, email: e.target.value })
                          }
                        />
                        <ValidationMessage error={errors} name="email" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="mobile_number">
                          Mobile Number<span className="text-danger">*</span>
                        </label>
                        <PhoneInput
                          country="in"
                          preferredCountries={["in"]}
                          enableSearch={true}
                          searchPlaceholder="Search country or code..."
                          searchNotFound="No country found"
                          searchStyle={{
                            width: "88%",
                            padding: "6px 8px",
                            fontSize: "14px",
                          }}
                          countryCodeEditable={true}
                          value={`${form.mobile_country_code || "91"}${form.mobile_number || ""}`}
                          onChange={(value, country) => {
                            const dial = country?.dialCode
                              ? String(country.dialCode)
                              : form.mobile_country_code || "91";
                            const rawNumber =
                              country?.dialCode && value.startsWith(dial)
                              ? value.slice(dial.length)
                              : value;
                            setForm({
                              ...form,
                              mobile_country_code: dial,
                              mobile_number: rawNumber,
                            });
                          }}
                          inputProps={{
                            id: "mobile_number",
                            name: "mobile_number",
                          }}
                          containerClass="w-100"
                          inputClass="form-control"
                          inputStyle={{ width: "100%" }}
                        />
                        <ValidationMessage
                          error={errors}
                          name="mobile_number"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="whatsapp_mobile_number"
                        >
                          Whatsapp Mobile Number
                          <span className="text-danger">*</span>
                        </label>
                        <PhoneInput
                          country="in"
                          preferredCountries={["in"]}
                          enableSearch={true}
                          searchPlaceholder="Search country or code..."
                          searchNotFound="No country found"
                          searchStyle={{
                            width: "88%",
                            padding: "6px 8px",
                            fontSize: "14px",
                          }}
                          countryCodeEditable={true}
                          value={`${form.whatsapp_country_code || "91"}${form.whatsapp_mobile_number || ""}`}
                          onChange={(value, country) => {
                            const dial = country?.dialCode
                              ? String(country.dialCode)
                              : form.whatsapp_country_code || "91";
                            const rawNumber =
                              country?.dialCode && value.startsWith(dial)
                              ? value.slice(dial.length)
                              : value;
                            setForm({
                              ...form,
                              whatsapp_country_code: dial,
                              whatsapp_mobile_number: rawNumber,
                            });
                          }}
                          inputProps={{
                            id: "whatsapp_mobile_number",
                            name: "whatsapp_mobile_number",
                          }}
                          containerClass="w-100"
                          inputClass="form-control"
                          inputStyle={{ width: "100%" }}
                        />
                        <ValidationMessage
                          error={errors}
                          name="whatsapp_mobile_number"
                        />
                      </div>
                    </div>

                    {/* <div className="col-md-6">
                      <div className="">
                        <label className="form-label d-block">
                          Gender <span className="text-danger">*</span>
                        </label>
                        <div className="form-check form-check-inline mt-2">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="gender"
                            id="genderMale"
                            value="male"
                            onChange={(e) =>
                              setForm({ ...form, gender: e.target.value })
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor="genderMale"
                          >
                            Male
                          </label>
                        </div>
                        <div className="form-check form-check-inline mt-2">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="gender"
                            id="genderFemale"
                            value="female"
                            onChange={(e) =>
                              setForm({ ...form, gender: e.target.value })
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor="genderFemale"
                          >
                            Female
                          </label>
                        </div>
                      </div>
                      <ValidationMessage error={errors} name="gender" />
                    </div> */}


                    {/* <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="username"
                        >
                          Username<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control hide-arrow"
                          id="username"
                          placeholder="Username"
                          onChange={(e) =>
                            setForm({ ...form, username: e.target.value })
                          }
                        />
                        <ValidationMessage error={errors} name="username" />
                      </div>
                    </div> */}


                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="password">
                          Password<span className="text-danger">*</span>
                        </label>
                        <div className="input-group input-group-merge">
                          <input
                            type={type}
                            className="form-control"
                            id="password"
                            name="member_password"
                            placeholder="***********"
                            autoComplete="new-password"
                            aria-describedby="basic-default-password"
                            value={form?.password || ""}
                            onChange={(e) =>
                              setForm({ ...form, password: e.target.value })
                            }
                          />
                          {type === "password" ? (
                            <span
                              className="input-group-text cursor-pointer"
                              id="basic-default-password"
                              onClick={() => setType("text")}
                            >
                              <i className="bx bx-hide"></i>
                            </span>
                          ) : (
                            <span
                              className="input-group-text cursor-pointer"
                              id="basic-default-password"
                              onClick={() => setType("password")}
                            >
                              <i className="bx bx-show"></i>
                            </span>
                          )}
                        </div>
                        <ValidationMessage error={errors} name="password" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="confirm_password"
                        >
                          Confirm Password<span className="text-danger">*</span>
                        </label>
                        <div className="input-group input-group-merge">
                          <input
                            type={type1}
                            className="form-control"
                            id="confirm_password"
                            name="member_confirm_password"
                            placeholder="***********"
                            autoComplete="new-password"
                            aria-describedby="basic-default-password"
                            value={form?.confirm_password || ""}
                            onChange={(e) =>
                              setForm({
                                ...form,
                                confirm_password: e.target.value,
                              })
                            }
                          />
                          {type1 === "password" ? (
                            <span
                              className="input-group-text cursor-pointer"
                              id="basic-default-password"
                              onClick={() => setType1("text")}
                            >
                              <i className="bx bx-hide"></i>
                            </span>
                          ) : (
                            <span
                              className="input-group-text cursor-pointer"
                              id="basic-default-password"
                              onClick={() => setType1("password")}
                            >
                              <i className="bx bx-show"></i>
                            </span>
                          )}
                        </div>
                        <ValidationMessage
                          error={errors}
                          name="confirm_password"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="company_name">
                          Company name<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control hide-arrow"
                          id="company_name"
                          name="member_company_name"
                          placeholder="Company name"
                          autoComplete="off"
                          value={form?.company_name || ""}
                          onChange={(e) =>
                            setForm({ ...form, company_name: e.target.value })
                          }
                        />
                        <ValidationMessage error={errors} name="company_name" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="address">
                          Address<span className="text-danger">*</span>
                        </label>
                        <textarea
                          type="text"
                          className="form-control hide-arrow"
                          id="address"
                          name="member_address"
                          rows="6"
                          maxlength="500"
                          placeholder="Address"
                          autoComplete="off"
                          value={form?.address || ""}
                          onChange={(e) =>
                            setForm({ ...form, address: e.target.value })
                          }
                        />
                        <ValidationMessage error={errors} name="address" />
                      </div>
                    </div>

                    <div className="col-6">
                      <div className="d-flex justify-content-between">
                        <label htmlFor="profile_image" className="form-label">
                          Profile Image (1:1) (ex. 256wx256h)
                        </label>
                        <div className="d-flex gap-3 image-info">
                          <div>
                            <label>Max :</label>
                            <span>2MB</span>
                          </div>
                          {/* <div>
                            <label htmlFor="pixel">Min height*width: </label>
                            <span>430px * 600px</span>
                          </div> */}
                        </div>
                      </div>
                      <input
                        type="file"
                        className="form-control"
                        accept="image/jpeg, image/png, image/jpg"
                        onChange={(e) =>
                          e.target.files.length > 0
                            ? setForm({
                                ...form,
                                profile_image: e.target.files[0],
                                cardImage: URL.createObjectURL(
                                  e.target.files[0],
                                ),
                              })
                            : ""
                        }
                      />
                      <div className="m-3">
                        <Image
                          width={80}
                          height={80}
                          src={form?.cardImage ? form?.cardImage : userIcon}
                          onError={(e) => {
                            e.target.src = userIcon;
                          }}
                          rounded
                        />
                      </div>
                      <ValidationMessage error={errors} name="profile_image" />
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="bio_description">
                          Bio Description
                        </label>
                        <textarea
                          type="text"
                          className="form-control hide-arrow"
                          id="bio_description"
                          rows="6"
                          maxlength="250"
                          placeholder="Bio description"
                          onChange={(e) =>
                            setForm({
                              ...form,
                              bio_description: e.target.value,
                            })
                          }
                        />
                        <ValidationMessage
                          error={errors}
                          name="bio_description"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="our_products_and_services"
                        >
                          Our Products and Services
                        </label>
                        <textarea
                          type="text"
                          className="form-control hide-arrow"
                          id="our_products_and_services"
                          rows="6"
                          maxlength="250"
                          placeholder="Our Products and Services"
                          onChange={(e) =>
                            setForm({
                              ...form,
                              our_products_and_services: e.target.value,
                            })
                          }
                        />
                        <ValidationMessage
                          error={errors}
                          name="our_products_and_services"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="dob">
                          Date of Birth
                        </label>
                        <Flatpickr
                          className="form-control"
                          options={{
                            dateFormat: "d/m/Y",
                            enableTime: false,
                            maxDate: moment()
                              .subtract(18, "years")
                              .format("DD/MM/YYYY"),
                          }}
                          onChange={(selected) =>
                            setForm({
                              ...form,
                              dob: moment(selected[0]).format("DD/MM/YYYY"),
                            })
                          }
                          placeholder="Select Date of Birth"
                        />
                      </div>
                    </div>

                    {hasRole([1]) && (
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="country_id" className="form-label">
                            Country<span className="text-danger">*</span>
                          </label>
                          <Select
                            isClearable
                            options={countryOptions}
                            onChange={(selected) => {
                              handleStateClear();
                              setForm({
                                ...form,
                                country_id: selected?.value,
                                state_id: null,
                                region_id: null,
                                chapter_id: null,
                              });
                              setFilter({
                                ...filter,
                                country_id: selected?.value,
                                state_id: null,
                                region_id: null,
                                chapter_id: null,
                              });
                            }}
                          />
                          <ValidationMessage error={errors} name="country_id" />
                        </div>
                      </div>
                    )}

                    {hasRole([1, 6]) && (
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="state_id" className="form-label">
                            State<span className="text-danger">*</span>
                          </label>
                          <Select
                            isClearable
                            ref={selectStateRef}
                            options={stateOptions}
                            onChange={(selected) => {
                            handleCityClear();
                            setForm({
                                ...form,
                                state_id: selected?.value,
                                region_id: null,
                                chapter_id: null,
                              });
                              setFilter({
                                ...filter,
                                state_id: selected?.value,
                                region_id: null,
                                chapter_id: null,
                              });
                            }}
                          />
                          <ValidationMessage error={errors} name="state_id" />
                        </div>
                      </div>
                    )}

                    {hasRole([1, 6, 7]) && (
                      <div className="col-6 mb-3">
                        <label htmlFor="city_id" className="form-label">
                          City<span className="text-danger">*</span>
                        </label>
                        <Select
                          ref={selectCityRef}
                          isClearable
                          name="city_id"
                          options={cityOptions}
                          onChange={(selected) => {
                            handleRegionClear();
                            setForm({
                              ...form,
                              city_id: Number(selected?.value),
                              region_id: null,
                              chapter_id: null,
                            });
                            setFilter({
                              ...filter,
                              city_id: selected?.value,
                              region_id: null,
                              chapter_id: null,
                            });
                          }}
                        />
                        <ValidationMessage error={errors} name="city_id" />
                      </div>
                    )}

                    {hasRole([1, 6, 7, 8]) && (
                      <div className="col-6 mb-3">
                        <label htmlFor="region_id" className="form-label">
                          Region<span className="text-danger">*</span>
                        </label>
                        <Select
                          isClearable
                          ref={selectRegionRef}
                          options={regionOptions}
                          onChange={(selected) => {
                            handleChapterClear();
                            setForm({
                              ...form,
                              region_id: selected?.value,
                              chapter_id: null,
                            });
                            setFilter({
                              ...filter,
                              region_id: selected?.value,
                              chapter_id: null,
                            });
                          }}
                        />
                        <ValidationMessage error={errors} name="region_id" />
                      </div>
                    )}

                    {hasRole([1, 6, 7, 8, 2]) && (
                      <div className="col-6 mb-3">
                        <label htmlFor="chapter_id" className="form-label">
                          Circle<span className="text-danger">*</span>
                        </label>
                        <Select
                          isClearable
                          ref={selectChapterRef}
                          options={chapterOptions}
                          onChange={(selected) => {
                            setForm({ ...form, chapter_id: selected?.value });
                            setFilter({
                              ...filter,
                              chapter_id: selected?.value,
                            });
                          }}
                        />
                        <ValidationMessage error={errors} name="chapter_id" />
                      </div>
                    )}

                    {/* <div className="col-6 mb-3">
                      <label htmlFor="member_type" className="form-label">
                        Member Type<span className="text-danger">*</span>
                      </label>
                      <Select
                        isClearable
                        options={memberTypeOptions}
                        onChange={(selected) => {
                          setForm({ ...form, member_type: selected?.value });
                        }}
                      />
                      <ValidationMessage error={errors} name="member_type" />
                    </div> */}

                    <div className="col-6 mb-3">
                      <label htmlFor="user_role_id" className="form-label">
                        User Role<span className="text-danger">*</span>
                      </label>
                      <Select
                        options={roleOptions}
                        onChange={(selected) =>
                          setForm({ ...form, user_role_id: selected.value })
                        }
                      />
                      <ValidationMessage error={errors} name="user_role_id" />
                    </div>

                    <div className="col-6 mb-3">
                      <label htmlFor="category_id" className="form-label">
                        Category<span className="text-danger">*</span>
                      </label>
                      <Select
                        options={categoryOptions}
                        onChange={(selected) => {
                          setForm({
                            ...form,
                            category_id: Number(selected.value),
                            sub_category_id: null,
                          });
                          // checkPanGstMandatory(selected.value);
                        }}
                      />
                      <ValidationMessage error={errors} name="category_id" />
                    </div>

                    <div className="col-6 mb-3">
                      <label htmlFor="sub_category_id" className="form-label">
                        Sub Category<span className="text-danger">*</span>
                      </label>
                      <Select
                        options={
                          Array.isArray(subCategoryOptions)
                            ? subCategoryOptions.filter(
                                (option) =>
                                  option.parent_id === Number(form.category_id),
                              )
                            : []
                        }
                        onChange={(selected) =>
                          setForm({
                            ...form,
                            sub_category_id: selected?.value,
                          })
                        }
                      />
                      <ValidationMessage
                        error={errors}
                        name="sub_category_id"
                      />
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="payment_date">
                          Payment Date<span className="text-danger">*</span>
                        </label>
                        <Flatpickr
                          className="form-control"
                          options={{
                            dateFormat: "d/m/Y",
                            enableTime: false,
                          }}
                          onChange={(selected) =>
                            setForm({
                              ...form,
                              payment_date: moment(selected[0]).format("DD/MM/YYYY"),
                            })
                          }
                          value={form?.payment_date || ""}
                          placeholder="Select Payment Date"
                        />
                        <ValidationMessage error={errors} name="payment_date" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <div className="d-flex justify-content-between">
                          <label className="form-label" htmlFor="payment_attachment">
                            Payment Attachment
                          </label>
                          <div className="image-info">
                            <span className="text-muted" style={{ fontSize: "12px" }}>Images or PDF (Max 5MB)</span>
                          </div>
                        </div>
                        <input
                          type="file"
                          id="payment_attachment"
                          name="payment_attachment"
                          className="form-control"
                          accept=".jpeg,.jpg,.png,.webp,.pdf,image/jpeg,image/png,image/webp,application/pdf"
                          onChange={(e) => {
                            if (e.target.files.length > 0) {
                              const file = e.target.files[0];
                              const isPdf = file.type === "application/pdf" || file.name.toLowerCase().endsWith(".pdf");
                              setForm({
                                ...form,
                                payment_attachment: file,
                                payment_attachment_preview: URL.createObjectURL(file),
                                payment_attachment_name: file.name,
                                payment_attachment_is_pdf: isPdf,
                              });
                            }
                          }}
                        />
                        {form?.payment_attachment_preview && (
                          <div className="mt-2 d-flex align-items-center gap-2">
                            {form?.payment_attachment_is_pdf ? (
                              <a
                                href={form.payment_attachment_preview}
                                target="_blank"
                                rel="noreferrer"
                                className="badge bg-label-danger text-decoration-none d-inline-flex align-items-center gap-1"
                                style={{ fontSize: "12px", padding: "6px 10px" }}
                              >
                                <i className="bx bxs-file-pdf font-size-14"></i> {form.payment_attachment_name || "View Selected PDF"}
                              </a>
                            ) : (
                              <img
                                src={form.payment_attachment_preview}
                                alt="Payment Attachment Preview"
                                style={{
                                  maxHeight: "70px",
                                  maxWidth: "120px",
                                  objectFit: "contain",
                                  borderRadius: "4px",
                                  border: "1px solid #ddd",
                                  padding: "2px",
                                }}
                              />
                            )}
                          </div>
                        )}
                        <ValidationMessage error={errors} name="payment_attachment" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="date_of_joining">
                          Date of Joining<span className="text-danger">*</span>
                        </label>
                        <Flatpickr
                          className="form-control"
                          options={{
                            dateFormat: "d/m/Y",
                            enableTime: false,
                          }}
                          onChange={(selected) => {
                            const joining = moment(selected[0]).format("DD/MM/YYYY");
                            const years = form.membership_duration_years || 1;
                            setForm({
                              ...form,
                              date_of_joining: joining,
                              membership_due_date: calcMembershipDueDate(joining, years),
                            });
                          }}
                          placeholder="Select Date of Joining"
                        />
                        <ValidationMessage
                          error={errors}
                          name="date_of_joining"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="membership_duration_years"
                        >
                          Membership Duration (Years)
                          <span className="text-danger">*</span>
                        </label>
                        <Select
                          options={membershipDurationOptions}
                          value={membershipDurationOptions.find(
                            (o) => o.value === Number(form.membership_duration_years || 1),
                          )}
                          onChange={(selected) => {
                            const years = selected?.value || 1;
                            setForm({
                              ...form,
                              membership_duration_years: years,
                              membership_due_date: calcMembershipDueDate(
                                form.date_of_joining,
                                years,
                              ),
                            });
                          }}
                        />
                        <ValidationMessage
                          error={errors}
                          name="membership_duration_years"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="membership_due_date"
                        >
                          Membership Due Date
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="membership_due_date"
                          readOnly
                          value={form?.membership_due_date || ""}
                          placeholder="Auto-calculated from joining date and duration"
                        />
                        <ValidationMessage
                          error={errors}
                          name="membership_due_date"
                        />
                      </div>
                    </div>

                    <div className="col-6 mb-3">
                      <label htmlFor="blood_group_id" className="form-label">
                        Blood Group
                      </label>
                      <Select
                        isClearable
                        options={bloodGroupOptions}
                        onChange={(selected) =>
                          setForm({
                            ...form,
                            blood_group_id: selected?.value ?? "",
                          })
                        }
                      />
                      <ValidationMessage error={errors} name="blood_group_id" />
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="gst">
                          GST Number
                          {isGSTMandatory && (
                            <span className="text-danger">*</span>
                          )}
                        </label>
                        <input
                          type="text"
                          className="form-control hide-arrow"
                          id="gst"
                          placeholder="Gst"
                          onChange={(e) =>
                            setForm({
                              ...form,
                              gst: e.target.value.toUpperCase(),
                            })
                          }
                          value={form?.gst?.toUpperCase()}
                        />
                        <ValidationMessage error={errors} name="gst" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="pan">
                          Pan Number
                          {isPANMandatory && (
                            <span className="text-danger">*</span>
                          )}
                        </label>
                        <input
                          type="text"
                          className="form-control hide-arrow"
                          id="pan"
                          placeholder="Pan"
                          onChange={(e) =>
                            setForm({
                              ...form,
                              pan: e.target.value.toUpperCase(),
                            })
                          }
                          value={form?.pan?.toUpperCase()}
                        />
                        <ValidationMessage error={errors} name="pan" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="website">
                          Website
                        </label>
                        <input
                          type="url"
                          className="form-control hide-arrow"
                          id="website"
                          placeholder="Website"
                          onChange={(e) =>
                            setForm({ ...form, website: e.target.value })
                          }
                        />
                        <ValidationMessage error={errors} name="website" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="instagram_url">
                          Instagram Url
                        </label>
                        <input
                          type="url"
                          className="form-control hide-arrow"
                          id="instagram_url"
                          placeholder="Instagram Url"
                          onChange={(e) =>
                            setForm({ ...form, instagram_url: e.target.value })
                          }
                        />
                        <ValidationMessage
                          error={errors}
                          name="instagram_url"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="linkedin_url">
                          Linkedin Url
                        </label>
                        <input
                          type="url"
                          className="form-control hide-arrow"
                          id="linkedin_url"
                          placeholder="Linkedin Url"
                          onChange={(e) =>
                            setForm({ ...form, linkedin_url: e.target.value })
                          }
                        />
                        <ValidationMessage error={errors} name="linkedin_url" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="twitter_url">
                          Twitter Url
                        </label>
                        <input
                          type="url"
                          className="form-control hide-arrow"
                          id="twitter_url"
                          placeholder="Twitter Url"
                          onChange={(e) =>
                            setForm({ ...form, twitter_url: e.target.value })
                          }
                        />
                        <ValidationMessage error={errors} name="twitter_url" />
                      </div>
                    </div>

                    {/* <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="facebook_url"
                        >
                          Facebook Url
                        </label>
                        <input
                          type="url"
                          className="form-control hide-arrow"
                          id="facebook_url"
                          placeholder="Facebook Url"
                          onChange={(e) =>
                            setForm({ ...form, facebook_url: e.target.value })
                          }
                        />
                        <ValidationMessage error={errors} name="facebook_url" />
                      </div>
                    </div> */}

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="youtube_url">
                          Youtube Url
                        </label>
                        <input
                          type="url"
                          className="form-control hide-arrow"
                          id="youtube_url"
                          placeholder="Youtube Url"
                          onChange={(e) =>
                            setForm({ ...form, youtube_url: e.target.value })
                          }
                        />
                        <ValidationMessage error={errors} name="youtube_url" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="referred_by">
                          Referred By<span className="text-danger">*</span>
                        </label>
                        <Select
                          name="referred_by"
                          options={referredByOptions}
                          onChange={(selected) => {
                            setForm({ ...form, referred_by: selected.value });
                            selected.value === 2
                              ? setShowReferredByMember(true)
                              : setShowReferredByMember(false);
                            selected.value === 3
                              ? setShowOthers(true)
                              : setShowOthers(false);
                          }}
                        />
                        <ValidationMessage error={errors} name="referred_by" />
                      </div>
                    </div>

                    {showReferredByMember && (
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label" htmlFor="referrer_id">
                            Referrer Members
                            <span className="text-danger">*</span>
                          </label>
                          <Select
                            name="referrer_id"
                            options={userOptions}
                            onChange={(selected) =>
                              setForm({ ...form, referrer_id: selected.value })
                            }
                          />
                          <ValidationMessage
                            error={errors}
                            name="referrer_id"
                          />
                        </div>
                      </div>
                    )}

                    {showOthers && (
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label" htmlFor="referrer_name">
                            Referrer Name<span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control hide-arrow"
                            id="referrer_name"
                            placeholder="Referrer name"
                            onChange={(e) =>
                              setForm({
                                ...form,
                                referrer_name: e.target.value,
                              })
                            }
                          />
                          <ValidationMessage
                            error={errors}
                            name="referrer_name"
                          />
                        </div>
                      </div>
                    )}

                    {showOthers && (
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label
                            className="form-label"
                            htmlFor="referrer_mobile"
                          >
                            Referrer Mobile Number
                          </label>
                          <input
                            type="text"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            maxLength={15}
                            className="form-control hide-arrow"
                            id="referrer_mobile"
                            placeholder="Referrer Mobile Number"
                            value={form.referrer_mobile || ""}
                            onKeyDown={(e) => {
                              if (
                                !/^[0-9]$/.test(e.key) &&
                                ![
                                  "Backspace",
                                  "Delete",
                                  "Tab",
                                  "Escape",
                                  "Enter",
                                  "ArrowLeft",
                                  "ArrowRight",
                                ].includes(e.key) &&
                                !e.ctrlKey &&
                                !e.metaKey
                              ) {
                                e.preventDefault();
                              }
                            }}
                            onChange={(e) => {
                              const val = e.target.value.replace(/\D/g, "");
                              setForm({
                                ...form,
                                referrer_mobile: val,
                              });
                              if (errors?.referrer_mobile) {
                                if (!val || /^\d{6,15}$/.test(val)) {
                                  setErrors((prev) => {
                                    const next = { ...prev };
                                    delete next.referrer_mobile;
                                    return next;
                                  });
                                }
                              }
                            }}
                            onBlur={(e) => {
                              const val = e.target.value;
                              if (val && !/^\d{6,15}$/.test(val)) {
                                setErrors((prev) => ({
                                  ...prev,
                                  referrer_mobile: [
                                    "Referrer mobile number did not match the pattern.",
                                  ],
                                }));
                              }
                            }}
                          />
                          <ValidationMessage
                            error={errors}
                            name="referrer_mobile"
                          />
                        </div>
                      </div>
                    )}
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="membership_status"
                        >
                          Membership Status
                        </label>
                        <Form.Check
                          type="switch"
                          id="custom-switch"
                          value="1"
                          checked={form.membership_status === 1 ? true : false}
                          label=""
                          onChange={(event) => {
                            const statusVal = event.target.checked ? 1 : 0;
                            setForm({
                              ...form,
                              membership_status: statusVal,
                              date_time: moment().format("YYYY-MM-DD HH:mm"),
                              ...(statusVal === 1 ? { reason: "" } : {}),
                            });
                          }}
                        />
                        <ValidationMessage
                          error={errors}
                          name="membership_status"
                        />
                      </div>
                    </div>

                    {Number(form?.membership_status) === 0 && (
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label
                            className="form-label"
                            htmlFor="reason"
                          >
                            Reason
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="reason"
                            name="reason"
                            placeholder="Enter Reason"
                            value={form?.reason || ""}
                            onChange={(e) =>
                              setForm({
                                ...form,
                                reason: e.target.value,
                              })
                            }
                          />
                          <ValidationMessage
                            error={errors}
                            name="reason"
                          />
                        </div>
                      </div>
                    )}

                    <div className="demo-inline-spacing d-flex justify-content-end">
                      <Link to={"/users"}>
                        <button
                          type="button"
                          className="btn btn-primary iclose_btn"
                        >
                          Close
                        </button>
                      </Link>
                      <button
                        disabled={btnDisabled}
                        type="button"
                        className="btn btn-success isubmit_button"
                        onClick={(e) => submit(e)}
                      >
                        &nbsp; Save
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserCreate;
